import React, { FC } from 'react'
import { ErrorImage } from '../../assets/icons'
import { Linking, View } from 'react-native'
import { Trans, useTranslation } from 'react-i18next'
import { Text } from 'react-native-paper'
import { useResponsive } from '../../utils/hooks'
import { styles } from './styles'

export enum ErrorCode {
  AlreadyApproved = 'document_already_approved',
  TokenExpired = 'approval_token_expired',
  UnhandledError = 'unhandled',
}

interface IApprovalErrorMessageProps {
  errorCode: ErrorCode
}

export const ApprovalErrorMessage: FC<IApprovalErrorMessageProps> = ({
  errorCode,
}) => {
  const { t } = useTranslation('global')
  const { sm } = useResponsive()

  const title =
    errorCode === ErrorCode.TokenExpired
      ? 'DocumentApproval.approval-expired-title'
      : 'DocumentApproval.approval-error-title'

  const message =
    errorCode === ErrorCode.TokenExpired
      ? 'DocumentApproval.approval-expired-message'
      : 'DocumentApproval.approval-error-message'

  return (
    <View style={[styles.wrapper, { width: sm ? 590 : 350 }]}>
      <ErrorImage />
      <Text style={styles.title}>{t(title)}</Text>
      <Text style={styles.message}>
        <Trans
          t={t}
          i18nKey={message}
          components={{
            email: (
              <Text
                onPress={() => Linking.openURL('mailto:support@bluetape.com')}
                style={{
                  fontWeight: '600',
                  color: '#00A0F3',
                }}
              >
                support@bluetape.com
              </Text>
            ),
          }}
        />
      </Text>
    </View>
  )
}
